import { SafeArea } from '@capacitor-community/safe-area';
SafeArea.enable({ config: {} });
